<template>
  <div class="ktb-fast-pay-container">
    <div class="navbar navbar-expand navbar-light bg-primary mb-4">
      <div class="container">
        <span class="navbar-brand text-white">
          <i class="fas fa-credit-card mr-2"></i>KTB Fast Pay
        </span>
      </div>
    </div>
    
    <div class="container py-4">
      <b-row class="justify-content-center">
        <b-col cols="12" md="8" lg="6">
          <b-card class="shadow-sm">
            <template #header>
              <div class="text-center">
                <h3 class="mb-0 text-primary">KTB Fast Pay</h3>
              </div>
            </template>

            <div class="clinic-info mb-4">
              <div class="p-3 bg-light rounded">
                <h5 class="mb-3">ข้อมูลคลินิก</h5>
                <div class="d-flex justify-content-between mb-2">
                  <span>คลินิก:</span>
                  <strong>{{ clinicName }}</strong>
                </div>
                <div class="d-flex justify-content-between">
                  <span>สาขา:</span>
                  <strong>{{ branchName }}</strong>
                </div>
              </div>
            </div>

            <b-form @submit.prevent="submitPayment">
              <h5 class="mb-3">Select Amount</h5>
              
              <div class="amount-buttons mb-4">
                <b-row>
                  <b-col cols="4" v-for="amount in predefinedAmounts" :key="amount" class="mb-2">
                    <b-button
                      block
                      :variant="selectedAmount === amount ? 'primary' : 'outline-secondary'"
                      @click="selectAmount(amount)"
                    >
                      {{ formatCurrency(amount) }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              
              <b-form-group label="Custom Amount (บาท):" label-for="custom-amount">
                <b-form-input
                  id="custom-amount"
                  v-model="customAmount"
                  type="number"
                  placeholder="กรุณากรอกจำนวนเงิน"
                  :disabled="loading"
                  @input="updateSelectedAmount"
                ></b-form-input>
              </b-form-group>

              <div class="payment-summary p-3 bg-light rounded mb-4">
                <div class="d-flex justify-content-between">
                  <span>Total Amount:</span>
                  <strong>{{ formatCurrency(selectedAmount || 0) }}</strong>
                </div>
              </div>

              <div class="text-center mt-4">
                <b-button
                  variant="secondary"
                  class="mr-2"
                  :disabled="loading"
                  @click="cancel"
                >
                  Cancel
                </b-button>
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="loading || !selectedAmount"
                >
                  <b-spinner small v-if="loading" class="mr-2"></b-spinner>
                  Proceed to Payment
                </b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <Dialog ref="Dialog"></Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/modal/Dialog.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "KtbFastPay",
  components: {
    Dialog
  },
  data() {
    return {
      clinicUrl: this.$route.params.clinicUrl || "mmdc",
      branchUrl: this.$route.params.branchUrl || "sukapiban5",
      predefinedAmounts: [100, 200, 300, 500, 1000],
      selectedAmount: null,
      customAmount: null
    };
  },
  computed: {
    ...mapGetters({
      getBranchInfo: "moduleUser/getBranchInfo",
      loading: "modulePayment/getKtbFastPayLoading",
      paymentError: "modulePayment/getKtbFastPayError"
    }),
    clinicName() {
      return this.getBranchInfo?.clinic?.name || this.clinicUrl;
    },
    branchName() {
      return this.getBranchInfo?.name || this.branchUrl;
    }
  },
  methods: {
    ...mapActions({
      processKtbFastPayPayment: "modulePayment/processKtbFastPayPayment"
    }),
    selectAmount(amount) {
      this.selectedAmount = amount;
      this.customAmount = null;
    },
    updateSelectedAmount() {
      if (this.customAmount) {
        this.selectedAmount = parseFloat(this.customAmount);
      } else {
        this.selectedAmount = null;
      }
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '฿0.00';
      return `฿${value.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    },
    async submitPayment() {
      if (!this.selectedAmount || this.selectedAmount <= 0) {
        this.$refs.Dialog.showToast("error", "กรุณาเลือกจำนวนเงิน");
        return;
      }

      try {
        // Generate return URLs
        const baseUrl = window.location.origin;
        const successUrl = `${baseUrl}/${this.clinicUrl}/${this.branchUrl}/ktbfastpay/success`;
        const failUrl = `${baseUrl}/${this.clinicUrl}/${this.branchUrl}/ktbfastpay/fail`;
        const cancelUrl = `${baseUrl}/${this.clinicUrl}/${this.branchUrl}/ktbfastpay/cancel`;
        
        await this.processKtbFastPayPayment({
          clinicUrl: this.clinicUrl,
          branchUrl: this.branchUrl,
          amount: this.selectedAmount,
    
        });
      } catch (error) {
        console.error("KTB Fast Pay error:", error);
        this.$refs.Dialog.showToast("error", error.message || "เกิดข้อผิดพลาดในการทำรายการ");
      }
    },
    cancel() {
      this.$router.go(-1);
    }
  },
  watch: {
    paymentError(error) {
      if (error) {
        this.$refs.Dialog.showToast("error", error);
      }
    }
  }
};
</script>

<style scoped>
.ktb-fast-pay-container {
  min-height: 100vh;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
}

.navbar {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.container {
  flex-grow: 1;
}

.amount-buttons .btn {
  font-weight: 500;
}

.payment-summary {
  border: 1px solid #dee2e6;
}

@media (max-width: 768px) {
  .container {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}
</style>